import { Component, OnDestroy, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';
import { BasePageComponent } from '../../../base-page';
import { IAppState } from '../../../../interfaces/app-state';
import { HttpService } from '../../../../services/http/http.service';

@Component({
  selector: 'page-icons-if',
  templateUrl: './icons-if.component.html',
  styleUrls: ['./icons-if.component.scss']
})
export class PageIconsIfComponent extends BasePageComponent implements OnInit, OnDestroy {
  icons: string[];

  constructor(
    store: Store<IAppState>,
    httpSv: HttpService
  ) {
    super(store, httpSv);

    this.icons = [];

    this.pageData = {
      title: 'Icofont icons',
      key: '',
      breadcrumbs: [
        {
          title: 'UI Kit',
          key: '',
          route: 'dashboard'
        },
        {
          title: 'Icons',
          key: '',
          route: 'dashboard'
        },
        {
          title: 'Icofont',
          key: ''
        }
      ]
    };
  }

  ngOnInit() {
    super.ngOnInit();

    this.getData('assets/data/icons-icofont.json', 'icons', 'setLoaded');
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
